var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.9,25c0,0,8.1-11,18-11s18,11,18,11s-8.1,11-18,11S5.9,25,5.9,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M23.9,14c9.9,0,18,11,18,11s-8.1,11-18,11s-18-11-18-11S14,14,23.9,14 M23.9,12C13.1,12,4.7,23.4,4.3,23.9 L3.5,25l0.9,1.2C4.7,26.7,13.1,38,23.9,38c10.8,0,19.3-11.3,19.6-11.8l0.9-1.2l-0.9-1.2C43.2,23.4,34.8,12,23.9,12L23.9,12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00acc1",
    d: "M14.9,25c0-5,4-9,9-9c5,0,9,4,9,9c0,5-4,9-9,9C19,34,14.9,30,14.9,25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#006064",
    d: "M19.9,25c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4C21.7,29,19.9,27.2,19.9,25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M6,25c0.5-0.7,8.4-11,18-11c9.6,0,17.4,10.3,18,11l5,0l-1.7-2.3C44.8,22.2,35.8,10,23.9,10S3.1,22.2,2.7,22.7 L1,25H6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPreview);
export default __webpack_public_path__ + "static/media/card-preview.71bee50b842ef4ad517b08ffbf735d32.svg";
export { ForwardRef as ReactComponent };